module.exports = {"available":"libre","booked":"Réservé","occupied":"Occupé","booked-occupied":"Réservé / Occupé","used":"utilisé","until":"jusqu'à","all-day":"toute la journée","page_over_total":"page {page} sur {total}","room-name":"nom de la salle","current-booking":"en cours","next-booking":"prochainement","unknown":"inconnu","floors":"étages","today":"aujourd'hui","no_bookings":"Aucun booking n'est planifié pour aujourd'hui.","no_information":"Aucune information.","description":"Description","capacity":"Capacité","allocated":"Alloué","booked-occupied-allocated":"Réservé / Occupé / Alloué"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/fr.json
// module id = OhdL
// module chunks = 2